module.exports = "<div class=c-basket__reservation-details ng-if=$ctrl.displayReference()> <span class=c-basket__reservation__reference>Currently editing {{ $ctrl.displayReference() }}</span> <span class=c-basket__reservation__dates>{{ $ctrl.displayDates() }}</span> <hr> </div> ";


//////////////////
// WEBPACK FOOTER
// ./frontend/storefront/app/modules/basket/views/editReservationDetails.html
// module id = 694
// module chunks = 0